import { useIntl } from 'react-intl'
import { colors } from '../constants'

function useTitle(color) {
    const intl = useIntl()

    switch (color) {
        case colors.purple:
            return intl.formatMessage({ id: 'windows.notification.title' })
        case colors.white:
            return intl.formatMessage({ id: 'windows.notification.title' })
        case colors.transparent:
            return intl.formatMessage({ id: 'windows.notification.title' })
        case colors.red:
            return intl.formatMessage({ id: 'windows.error.title' })
        case colors.green:
            return intl.formatMessage({ id: 'windows.success.title' })
        case colors.blue:
            return intl.formatMessage({ id: 'windows.info.title' })

        default:
            return 'CineStar'
    }
}

export default useTitle
